import styled from 'styled-components';

export const StyledLinkSectionButton = styled.div`
  display: flex;
  justify-content: center;
  margin: 2rem 0;
`;

export const StyledButton = styled.a`
  display: inline-block;
  padding: 0.75rem 1.5rem;
  font-family: var(--font-geomanist);
  font-weight: 600;
  font-size: 1rem;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.3s ease;
  color: white;
  background: linear-gradient(135deg, hsla(240, 100%, 50%, 1) 0%, hsla(357, 91%, 51%, 1) 100%);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }

  &:active {
    transform: translateY(0);
  }
`;
